import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getexpenses } from '../redux/expenses';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    document.getElementById("descriptionpay").value = '';
  };

  const addPay = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post("https://embert.sisrevolution.com/api/expenses/editexpenses/", {
        id: props.chosen.id,
        description: document.getElementById("descriptionpay").value,
        status: "Payout",
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getexpenses({ data: res.data }));
        setSnackbarMessage('Payout submitted successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to submit payout.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error submitting payout.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Payout
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <form onSubmit={addPay}>
              <TextField
                id="descriptionpay"
                required
                label="Description"
                type="text"
                style={{ width: "98%", marginTop: "15px" }}
                autoComplete="current-text"
              />
              <br />
              <br />
              <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
                {loading ? (
                  <Button variant="outlined" disabled>
                    Loading...
                  </Button>
                ) : (
                  <Button type="submit" variant="outlined" size="large">
                    Payout
                  </Button>
                )}
              </div>
            </form>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}